import { render, staticRenderFns } from "./StepForm.vue?vue&type=template&id=1b988c7f&scoped=true&"
import script from "./StepForm.vue?vue&type=script&lang=js&"
export * from "./StepForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b988c7f",
  null
  
)

export default component.exports